(() => {
  const EU_COUNTRIES = new Set([
    'AT', 'BE', 'BG', 'CY', 'CZ', 'DE', 'DK', 'EE', 'ES', 'FI', 'FR', 'GR', 'HR',
    'HU', 'IE', 'IT', 'LT', 'LU', 'LV', 'MT', 'NL', 'PL', 'PT', 'RO', 'SE', 'SI', 'SK'
  ]);

  const stripVat = (value) => (value || '').replace(/[\s.\-_]/g, '').toUpperCase();

  const isItalianVatValid = (number) => {
    if (!/^\d{11}$/.test(number)) return false;

    let sum = 0;
    for (let index = 0; index < 10; index += 1) {
      let digit = Number(number[index]);
      if (index % 2 === 1) {
        digit *= 2;
        if (digit > 9) digit -= 9;
      }
      sum += digit;
    }

    const checkDigit = (10 - (sum % 10)) % 10;
    return checkDigit === Number(number[10]);
  };

  const setStatus = (form, message, state) => {
    const statusEl = form.querySelector('[data-b2b-vat-status]');
    const vatEl = form.querySelector('[data-b2b-vat-input]');
    const hiddenEl = form.querySelector('[data-b2b-vat-state]');

    if (statusEl) {
      statusEl.textContent = message || '';
      statusEl.classList.remove('is-valid', 'is-invalid', 'is-checking');
      if (state) statusEl.classList.add(`is-${state}`);
    }

    if (vatEl) {
      vatEl.classList.remove('is-valid', 'is-invalid');
      if (state === 'valid' || state === 'invalid') vatEl.classList.add(`is-${state}`);
    }

    if (hiddenEl) {
      hiddenEl.value = state === 'valid' ? 'valid' : '';
    }
  };

  const parseVat = (country, rawValue) => {
    let vat = stripVat(rawValue);

    if (country === 'IT' && /^\d{11}$/.test(vat)) {
      vat = `IT${vat}`;
    }

    if (!EU_COUNTRIES.has(country)) {
      return { error: 'Seleziona un paese UE valido.' };
    }

    if (!vat) {
      return { error: 'Inserisci una partita IVA.' };
    }

    if (!vat.startsWith(country)) {
      return { error: `La partita IVA deve iniziare con ${country}.` };
    }

    const number = vat.slice(2);
    if (!/^[A-Z0-9]{2,12}$/.test(number)) {
      return { error: 'Formato VAT non valido.' };
    }

    if (country === 'IT' && !isItalianVatValid(number)) {
      return { error: 'Partita IVA italiana non valida.' };
    }

    return { vat, memberState: country, number };
  };

  const verifyVat = async (form) => {
    const countryEl = form.querySelector('[data-b2b-vat-country]');
    const vatEl = form.querySelector('[data-b2b-vat-input]');
    const taxTypeEl = form.querySelector('[data-b2b-tax-type]');

    if (!countryEl || !vatEl) return false;

    const country = (countryEl.value || '').toUpperCase();
    const parsed = parseVat(country, vatEl.value);

    if (parsed.error) {
      setStatus(form, parsed.error, 'invalid');
      return false;
    }

    vatEl.value = parsed.vat;
    if (taxTypeEl) taxTypeEl.value = 'EU_VAT_VERIFIED';

    setStatus(form, 'Verifica VAT in corso...', 'checking');

    try {
      const endpoint = `https://ec.europa.eu/taxation_customs/vies/rest-api/ms/${parsed.memberState}/vat/${parsed.number}`;
      const response = await fetch(endpoint, { method: 'GET' });
      if (!response.ok) throw new Error('VIES request failed');

      const data = await response.json();
      if (data && data.isValid) {
        setStatus(form, 'VAT verificata tramite VIES.', 'valid');
        return true;
      }

      setStatus(form, 'VAT non valida secondo VIES.', 'invalid');
      return false;
    } catch (error) {
      setStatus(form, 'Servizio VIES non disponibile. Riprova tra poco.', 'invalid');
      return false;
    }
  };

  const initForm = (root) => {
    if (root.dataset.b2bVatReady === 'true') return;

    const form = root.matches('form') ? root : root.querySelector('form');
    if (!form) return;

    const countryEl = form.querySelector('[data-b2b-vat-country]');
    const vatEl = form.querySelector('[data-b2b-vat-input]');
    const submitEl = form.querySelector('[data-b2b-vat-submit]');

    if (!countryEl || !vatEl || !submitEl) return;

    const reset = () => {
      const country = (countryEl.value || '').toUpperCase();
      const placeholder = country ? `${country}...` : 'IT12345678901';
      vatEl.placeholder = country === 'IT' ? 'IT12345678901' : placeholder;
      setStatus(form, '', null);
    };

    countryEl.addEventListener('change', reset);
    vatEl.addEventListener('input', () => setStatus(form, '', null));
    vatEl.addEventListener('blur', () => {
      if (vatEl.value.trim()) verifyVat(form);
    });

    form.addEventListener('submit', async (event) => {
      const stateEl = form.querySelector('[data-b2b-vat-state]');
      if (stateEl && stateEl.value === 'valid') return;

      event.preventDefault();

      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }

      submitEl.disabled = true;
      const isValid = await verifyVat(form);
      submitEl.disabled = false;

      if (isValid) {
        form.requestSubmit();
      }
    });

    reset();
    root.dataset.b2bVatReady = 'true';
  };

  document.querySelectorAll('[data-b2b-vat-form]').forEach(initForm);

  const observer = new MutationObserver(() => {
    document.querySelectorAll('[data-b2b-vat-form]').forEach(initForm);
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['hidden']
  });
})();
